import { render } from "./ExpandableListItem.vue?vue&type=template&id=546d6f95&scoped=true"
import script from "./ExpandableListItem.vue?vue&type=script&lang=js"
export * from "./ExpandableListItem.vue?vue&type=script&lang=js"

import "./ExpandableListItem.vue?vue&type=style&index=0&id=546d6f95&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546d6f95"],['__file',"src/components/ExpandableListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "546d6f95"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('546d6f95', __exports__)) {
    console.log('reload')
    api.reload('546d6f95', __exports__)
  }
  
  module.hot.accept("./ExpandableListItem.vue?vue&type=template&id=546d6f95&scoped=true", () => {
    console.log('re-render')
    api.rerender('546d6f95', render)
  })

}


export default __exports__